import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const LessonSummaryApiUtils = {
  fetchOne(summaryId) {
    return xhr(`${ApiConstants.FetchSummary}/${summaryId}`);
  },
  fetchOneByLessonId(lessonId) {
    return xhr(`${ApiConstants.FetchSummaryByLessonId}/${lessonId}`);
  },

  create(lessonId, params) {
    return xhr(ApiConstants.Base + 'lessons/' + lessonId + '/summaries', {
      method: 'post',
      body: JSON.stringify(params),
    });
  },

  update(lessonId, params) {
    return xhr(ApiConstants.Base + 'lessons/' + lessonId + '/summaries', {
      method: 'put',
      body: JSON.stringify(params),
    });
  },
};

export default LessonSummaryApiUtils;
